/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Interactant
 */
export interface Interactant {
    /**
     * 
     * @type {string}
     * @memberof Interactant
     */
    intActAccession: string;
    /**
     * 
     * @type {string}
     * @memberof Interactant
     */
    uniprotAccession: string;
    /**
     * 
     * @type {string}
     * @memberof Interactant
     */
    geneName: string;
}

/**
 * Check if a given object implements the Interactant interface.
 */
export function instanceOfInteractant(value: object): value is Interactant {
    if (!('intActAccession' in value) || value['intActAccession'] === undefined) return false;
    if (!('uniprotAccession' in value) || value['uniprotAccession'] === undefined) return false;
    if (!('geneName' in value) || value['geneName'] === undefined) return false;
    return true;
}

export function InteractantFromJSON(json: any): Interactant {
    return InteractantFromJSONTyped(json, false);
}

export function InteractantFromJSONTyped(json: any, ignoreDiscriminator: boolean): Interactant {
    if (json == null) {
        return json;
    }
    return {
        
        'intActAccession': json['intActAccession'],
        'uniprotAccession': json['uniprotAccession'],
        'geneName': json['geneName'],
    };
}

export function InteractantToJSON(json: any): Interactant {
    return InteractantToJSONTyped(json, false);
}

export function InteractantToJSONTyped(value?: Interactant | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'intActAccession': value['intActAccession'],
        'uniprotAccession': value['uniprotAccession'],
        'geneName': value['geneName'],
    };
}

